
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'CheckmarkIcon',
  props: {
    checked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'global'
    ]),
    successColor (): string {
      return this.global.successColor || '#337E33';
    }
  }
});
